import React from 'react';
import PDFIframeViewer from '../components/PDFIframeViewer';

const Dictionary: React.FC = () => {
  return <PDFIframeViewer />;
};

export default Dictionary; 